var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 262,
    viewBox: "0 0 126 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.38 101.336C217.525 122.341 213.393 152.157 208.438 175.414C203.642 197.92 184.349 205.208 166.408 219.617C147 235.203 134.611 257.67 110.902 250.091C88.1917 242.831 110.647 207.608 98.8409 186.894C88.6512 169.015 48.0878 159.857 47.7471 139.282C47.3175 113.336 44.4055 67.4963 63.9323 50.4066C84.8943 32.0607 112.903 71.9817 139.95 78.6448C165.763 85.0035 193.92 77.8523 206.38 101.336Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.155 106.948C210.202 125.884 206.478 152.764 202.011 173.73C197.687 194.019 180.295 200.589 164.121 213.578C146.626 227.629 135.458 247.883 114.084 241.05C93.6106 234.504 113.853 202.751 103.21 184.077C94.0239 167.959 57.4561 159.703 57.1487 141.154C56.761 117.764 54.1353 76.4391 71.7383 61.0329C90.6352 44.4943 115.885 80.4837 140.269 86.4908C163.538 92.2236 188.922 85.7771 200.155 106.948Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.921 110.508C205.21 128.015 201.769 152.863 197.641 172.245C193.647 191 177.57 197.073 162.62 209.079C146.449 222.067 136.126 240.79 116.368 234.472C97.4425 228.419 116.152 199.067 106.312 181.803C97.8195 166.902 64.0161 159.267 63.7305 142.119C63.3704 120.496 60.9401 82.2935 77.2109 68.0527C94.6777 52.7651 118.021 86.0371 140.561 91.5922C162.072 96.8936 185.536 90.9362 195.921 110.508Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.801 114.551C197.743 129.514 194.814 150.747 191.295 167.308C187.89 183.334 174.159 188.517 161.392 198.772C147.583 209.864 138.772 225.86 121.892 220.453C105.722 215.273 121.693 190.197 113.281 175.441C106.02 162.704 77.1409 156.166 76.8904 141.513C76.5744 123.035 74.4836 90.3881 88.3774 78.2249C103.292 65.1678 123.246 93.6092 142.503 98.365C160.881 102.904 180.922 97.8217 189.801 114.551Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.827 119.41C194.059 133.04 191.377 152.389 188.161 167.48C185.049 182.085 172.53 186.814 160.887 196.164C148.293 206.278 140.254 220.858 124.868 215.939C110.131 211.228 124.703 188.372 117.042 174.93C110.43 163.328 84.1078 157.386 83.8868 144.034C83.6082 127.198 81.7188 97.452 94.3902 86.3621C107.993 74.4571 126.168 100.362 143.72 104.686C160.47 108.812 178.741 104.171 186.827 119.41Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.494 124.075C187.799 135.958 185.457 152.828 182.65 165.988C179.933 178.722 169.015 182.847 158.861 191.002C147.877 199.823 140.863 212.536 127.448 208.25C114.597 204.145 127.308 184.214 120.63 172.495C114.866 162.381 91.9124 157.204 91.722 145.562C91.4819 130.883 89.8394 104.947 100.891 95.2756C112.755 84.8933 128.6 107.477 143.905 111.244C158.511 114.839 174.446 110.789 181.494 124.075Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.086 127.596C184.834 138.431 182.697 153.814 180.135 165.814C177.656 177.426 167.698 181.19 158.437 188.627C148.419 196.672 142.021 208.265 129.787 204.359C118.068 200.617 129.663 182.441 123.574 171.756C118.319 162.534 97.3871 157.817 97.215 147.201C96.998 133.816 95.5035 110.166 105.584 101.346C116.405 91.877 130.852 112.468 144.809 115.901C158.128 119.177 172.661 115.482 179.086 127.596Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.028 137.106C174.074 144.731 172.572 155.557 170.77 164.001C169.027 172.173 162.021 174.82 155.505 180.053C148.457 185.713 143.956 193.871 135.347 191.121C127.101 188.487 135.258 175.697 130.972 168.177C127.273 161.686 112.544 158.364 112.422 150.894C112.268 141.474 111.213 124.831 118.305 118.624C125.918 111.962 137.004 119.655 146.825 122.072C156.198 124.379 165.505 128.58 170.028 137.106Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.644 141.071C168.898 147.2 167.707 155.892 166.272 162.671C164.885 169.231 160.344 173.031 154.048 175.543C151.872 175.858 151.605 176.042 148.297 174.979C141.679 172.853 137.802 172.019 134.355 165.974C131.38 160.757 119.562 158.071 119.455 152.072C119.319 144.506 118.453 131.139 124.133 126.164C130.231 120.824 139.133 127.015 147.014 128.969C154.534 130.833 162.005 134.219 165.644 141.071Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.852 143.416C162.265 147.948 161.42 154.355 160.39 159.35C159.393 164.184 156.07 166.971 151.452 168.801C149.855 169.027 149.659 169.161 147.224 168.365C142.353 166.774 139.501 166.145 136.947 161.674C134.742 157.816 126.048 155.792 125.948 151.367C125.822 145.786 125.138 135.924 129.295 132.274C133.757 128.356 140.32 132.955 146.118 134.424C151.652 135.825 157.154 138.349 159.852 143.416Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightExperience);
export default __webpack_public_path__ + "static/media/Right-Experience.564c047e9aeba1d27fb032bc552f222f.svg";
export { ForwardRef as ReactComponent };